import { Link } from "react-router-dom";
import { Bookmark, MapPin, Clock } from "lucide-react";
import { CandidateAvatar, StatusBadge } from "@/components/Common";

export const CandidateCard = ({ c, base = "/app/candidates", shortlisted, onToggle }) => (
  <div data-testid={`candidate-card-${c.id}`} className="lift group flex min-w-0 flex-col rounded-md border border-stone-200 bg-white p-6">
    <div className="flex items-start gap-4">
      <CandidateAvatar candidate={c} className="h-16 w-16" />
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-lg font-bold leading-tight text-stone-900 truncate">{c.name}</h3>
          {onToggle && (
            <button
              data-testid={`shortlist-toggle-${c.id}`}
              onClick={() => onToggle(c.id)}
              aria-label="Toggle shortlist"
              className={`shrink-0 rounded-md p-1.5 transition-colors ${shortlisted ? "text-amber-600 bg-amber-50" : "text-stone-400 hover:text-stone-900 hover:bg-stone-100"}`}
            >
              <Bookmark className="h-4 w-4" fill={shortlisted ? "currentColor" : "none"} />
            </button>
          )}
        </div>
        <p className="text-sm text-stone-600 truncate">{c.title}</p>
        <div className="mt-2"><StatusBadge status={c.status} /></div>
      </div>
    </div>

    <dl className="mt-5 grid grid-cols-3 border-y border-stone-100 py-3 text-center">
      <div><dt className="text-[10px] font-mono uppercase tracking-wider text-stone-500">Rate</dt><dd className="font-display font-bold text-stone-900">${c.hourly_rate}/hr</dd></div>
      <div className="border-x border-stone-100"><dt className="text-[10px] font-mono uppercase tracking-wider text-stone-500">Exp.</dt><dd className="font-display font-bold text-stone-900">{c.experience_years} yrs</dd></div>
      <div><dt className="text-[10px] font-mono uppercase tracking-wider text-stone-500">Type</dt><dd className="font-display font-bold text-stone-900">{c.availability}</dd></div>
    </dl>

    <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-xs text-stone-500">
      <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{c.location}</span>
      <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{c.timezone}</span>
    </div>

    <div className="mt-4 flex flex-wrap gap-1.5">
      {(c.skills || []).slice(0, 4).map((s) => (
        <span key={s} className="rounded-sm bg-stone-100 px-2 py-0.5 text-xs text-stone-700">{s}</span>
      ))}
    </div>

    <Link
      to={`${base}/${c.id}`}
      data-testid={`view-profile-${c.id}`}
      className="mt-6 inline-flex items-center justify-center rounded-md border border-slate-900 px-4 py-2 text-sm font-medium text-slate-900 transition-colors hover:bg-slate-900 hover:text-white"
    >
      View full profile
    </Link>
  </div>
);
